import React from 'react'
import cancel from "../assests/5639820.webp"
function Cancel() {
  return (
    <div className='success-container'>
        <img src={cancel} alt="" className="success-image" />
      
    </div>
  )
}

export default Cancel
